export default "__VITE_ASSET__CIyfbtkd__"